import { AxiosResponse } from 'axios';
// this is the pagination code to use with codegen services. if you're using legacy-style
// code then you should use the interface from src/interfaces/pagination.tsx
export interface Pagination {
  // The cursor to start paginating after
  after?: string;
  // The cursor to stop paginating at
  before?: string;
  // The maximum number of paginated results to return
  limit: number;
  // The current page number
  // TODO: where does this come from?
  page: number;
}

export interface Paginated<T> {
  data: Array<T>;
  pagination: Pagination;
}

export type PaginationLink = ('after' | 'before') | undefined;

export interface PaginationQuery {
  // The maximum number of paginated results to return
  'page[limit]': number;
  // The cursor to start paginating after
  'page[after]'?: string;
  // The cursor to stop paginating at
  'page[before]'?: string;
  // catch anything else that might be in the query (eg search, filter, etc)
  [key: string]: number | string | undefined | boolean | string[];
}

export function extractPagination(response: AxiosResponse<unknown, unknown>): Pagination {
  const linkHeader = response.headers.link || '';
  const pagination = {} as Pagination;

  // Link header per RFC 8288: `<url1>; rel="next", <url2>; rel="prev"`.
  // URLSearchParams decodes percent-encoded keys, so this handles both
  // `page[after]=...` and `page%5Bafter%5D=...` forms.
  for (const entry of linkHeader.split(',')) {
    const urlMatch = entry.match(/<([^>]+)>/);
    if (!urlMatch) continue;
    const query = urlMatch[1].split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    const after = params.get('page[after]');
    const before = params.get('page[before]');
    if (after) pagination.after = after;
    if (before) pagination.before = before;
  }

  return pagination;
}
